var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhy3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.289,
    height: 49.465,
    viewBox: "0 0 31.289 49.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-power-2302619",
    transform: "translate(-170.124 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M408.448,66.367a2.254,2.254,0,0,1,.219.959,15.139,15.139,0,0,0-5.819-23.512.757.757,0,0,0-.592,1.394,13.623,13.623,0,0,1,5.727,20.521,2.242,2.242,0,0,1,.464.637Z",
    transform: "translate(-211.166 -39.967)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079_-_Outline",
    "data-name": "Path 1079 - Outline",
    d: "M408.172,68.722l-.006-1.394a1.765,1.765,0,0,0-.168-.742h0a1.736,1.736,0,0,0-.361-.5l-.314-.3.255-.353a13.123,13.123,0,0,0-5.517-19.768,1.257,1.257,0,1,1,.982-2.315,15.639,15.639,0,0,1,6.011,24.288Zm.727-2.57.012.026a14.64,14.64,0,0,0-6.259-21.9.257.257,0,0,0-.337.136.258.258,0,0,0,.136.338,14.122,14.122,0,0,1,6.167,20.946,2.747,2.747,0,0,1,.278.454l-.017.008Z",
    transform: "translate(-211.166 -39.967)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M175.961,69.283l.557-1.527A13.626,13.626,0,0,1,180.444,45.2a.757.757,0,0,0-.592-1.394,15.139,15.139,0,0,0-3.892,25.477Z",
    transform: "translate(0 -39.959)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080_-_Outline",
    "data-name": "Path 1080 - Outline",
    d: "M175.8,71.186l-.3-1.639a15.639,15.639,0,0,1,4.157-26.2,1.257,1.257,0,0,1,.983,2.315,13.126,13.126,0,0,0-3.783,21.728l.245.226Zm4.349-26.941a.255.255,0,0,0-.1.021,14.639,14.639,0,0,0-4.3,24.153l.192-.526a14.126,14.126,0,0,1,4.313-23.154.257.257,0,0,0-.1-.494Z",
    transform: "translate(0 -39.959)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M241.5,202.25,236.3,216.519a.757.757,0,0,0,.711,1.017h6.175l-5.059,13.748a.757.757,0,0,0,1.3.736l16.348-20.327a.757.757,0,0,0-.59-1.232h-6.093l3.434-7.027a1.514,1.514,0,0,0-1.361-2.179h-8.236a1.52,1.52,0,0,0-1.423,1Zm5.692,8.636a.758.758,0,0,0,.681,1.09H253.6l-12.46,15.492,3.838-10.428a.758.758,0,0,0-.711-1.019h-6.178l4.837-13.252h8.236Z",
    transform: "translate(-59.948 -183.838)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081_-_Outline",
    "data-name": "Path 1081 - Outline",
    d: "M242.925,200.755h8.237a2.014,2.014,0,0,1,1.81,2.9l-3.082,6.307h5.292a1.257,1.257,0,0,1,.98,2.045l-16.348,20.327a1.257,1.257,0,0,1-2.16-1.222l4.812-13.075h-5.458a1.257,1.257,0,0,1-1.181-1.688l5.583-15.3.139.251a2.036,2.036,0,0,1,.224-.181A2.007,2.007,0,0,1,242.925,200.755ZM238.833,231.8a.257.257,0,0,0,.2-.1l16.348-20.327a.257.257,0,0,0-.2-.419h-6.893l3.786-7.747a1.014,1.014,0,0,0-.911-1.46h-8.234a1.02,1.02,0,0,0-.954.667l-.1.275-5.107,13.993a.257.257,0,0,0,.242.345H243.9l-5.307,14.42a.256.256,0,0,0,.115.313A.254.254,0,0,0,238.833,231.8Zm3.744-29.533h9.386l-4.318,8.836a.258.258,0,0,0,.231.37h6.768L241.53,227.781l-.859-.486,3.838-10.428a.258.258,0,0,0-.242-.346h-6.893Zm7.784,1h-7.085L238.8,215.521h5.463a1.258,1.258,0,0,1,1.18,1.691l-2.784,7.563,9.892-12.3h-4.681a1.258,1.258,0,0,1-1.13-1.809Z",
    transform: "translate(-59.948 -183.838)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M342.007,0a.757.757,0,0,0-.757.757V15.9h1.514V.757A.757.757,0,0,0,342.007,0Z",
    transform: "translate(-155.861 0)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082_-_Outline",
    "data-name": "Path 1082 - Outline",
    d: "M342.007-.5A1.259,1.259,0,0,1,343.264.757V16.4H340.75V.757A1.259,1.259,0,0,1,342.007-.5Zm.257,15.9V.757a.257.257,0,1,0-.514,0V15.4Z",
    transform: "translate(-155.861 0)",
    fill: "#3d73ec"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy3);
export default __webpack_public_path__ + "static/media/why3.90a980f0cf2d2e49b96dc9b90e8630c1.svg";
export { ForwardRef as ReactComponent };